import React from 'react';
import { Field, Form } from 'react-final-form';

import { renderSelectField } from '../../../../Utils/renderField/renderField';
import { required } from '../../../../../../utility/validation';
import {
    ABANDONMENT,
    ACTIVE,
    INACTIVE,
    NOT_ENTER,
    DESERTED_OPTIONS_PRACTICE,
} from '../../../../../../utility/constants';

const STATUS_OPTIONS = [
    { value: ACTIVE, label: 'Activo' },
    { value: ABANDONMENT, label: 'Abandono' },
    { value: NOT_ENTER, label: 'No ingresó' },
    { value: INACTIVE, label: 'Inactivo' },
];

const DisabledBeneficiaryPracticeForm = ({ initialValues, onSubmit }) => {
    return (
        <Form initialValues={{ ...initialValues }} onSubmit={onSubmit}>
            {({ handleSubmit, submitting, values }) => {
                return (
                    <form
                        name="beneficiaryForm"
                        className="form-validate mb-lg"
                        onSubmit={handleSubmit}
                    >
                        <div className="d-flex flex-column flex-lg-row">
                            <div className="form-group has-feedback m-2 flex-1">
                                <label htmlFor="status_practice">
                                    Estado práctico del usuario
                                </label>
                                <Field
                                    name="status_practice"
                                    component={renderSelectField}
                                    options={STATUS_OPTIONS}
                                    isSearchable={false}
                                    validate={required}
                                    modal={true}
                                    className="form-control w-100"
                                />
                            </div>
                        </div>

                        {values.status_practice === ABANDONMENT && (
                            <div className="d-flex flex-column flex-lg-row">
                                <div className="form-group has-feedback m-2 flex-1">
                                    <label htmlFor="desertion_reason_practice">
                                        Razón de Abandono
                                    </label>
                                    <Field
                                        name="desertion_reason_practice"
                                        component={renderSelectField}
                                        isSearchable={false}
                                        type="text"
                                        validate={required}
                                        modal={true}
                                        options={DESERTED_OPTIONS_PRACTICE}
                                        className="form-control w-100"
                                    />
                                </div>
                            </div>
                        )}

                        <div className="container bg-light mt-4">
                            <div className="col-md-12 text-center">
                                <button
                                    type="submit"
                                    className="btn btn-primary "
                                    disabled={submitting}
                                >
                                    Guardar
                                </button>
                            </div>
                        </div>
                    </form>
                );
            }}
        </Form>
    );
};

export default DisabledBeneficiaryPracticeForm;
